/**
 * @param {import('leaflet')} L
 * @param {number} nx
 * @param {number} ny
 * @param {number} [aspectWOverH=1] pixel width / height; must match map image bounds
 */
export function normalizedToLeafletLatLng(L, nx, ny, aspectWOverH = 1) {
  const a = aspectWOverH > 0 ? aspectWOverH : 1;
  return L.latLng((1 - ny) / a, nx);
}

/** @param {import('leaflet').LatLng} ll */
export function leafletLatLngToNormalized(ll, aspectWOverH = 1) {
  const a = aspectWOverH > 0 ? aspectWOverH : 1;
  return [ll.lng, 1 - ll.lat * a];
}

/** @param {number[] | null | undefined} center */
export function parseImageMapCenter(center) {
  if (!center || center.length < 2) return null;
  const nx = center[0];
  const ny = center[1];
  if (!Number.isFinite(nx) || !Number.isFinite(ny)) return null;
  return [nx, ny];
}

/**
 * @param {import('leaflet')} L
 * @param {import('leaflet').Map} map
 * @param {[number, number]} center normalized [nx, ny]
 * @param {number} [aspectWOverH=1]
 */
export function applyImageMapCenterPan(L, map, center, aspectWOverH = 1) {
  map.panTo(normalizedToLeafletLatLng(L, center[0], center[1], aspectWOverH), {
    animate: false,
  });
}

/** @param {import('leaflet')} L */
export function imageMapPaddedMaxBounds(L, aspectWOverH, padFraction = 0.35) {
  const a = aspectWOverH > 0 ? aspectWOverH : 1;
  const maxLat = 1 / a;
  const maxLng = 1;
  const pLat = maxLat * padFraction;
  const pLng = maxLng * padFraction;
  return L.latLngBounds(L.latLng(-pLat, -pLng), L.latLng(maxLat + pLat, maxLng + pLng));
}

export const IMAGE_MAP_PAD_ZOOMED_OUT = 1;
export const IMAGE_MAP_PAD_ZOOMED_IN = 0.07;

/** @param {number} zoom @param {number} mapMinZoom @param {number} mapMaxZoom */
export function imageMapPadFractionForZoom(
  zoom,
  mapMinZoom,
  mapMaxZoom,
  padZoomedOut = IMAGE_MAP_PAD_ZOOMED_OUT,
  padZoomedIn = IMAGE_MAP_PAD_ZOOMED_IN,
) {
  const span = mapMaxZoom - mapMinZoom;
  if (span <= 0) return padZoomedIn;
  const t = Math.min(1, Math.max(0, (zoom - mapMinZoom) / span));
  return padZoomedOut + (padZoomedIn - padZoomedOut) * t;
}

/** @param {import('leaflet')} L @param {import('leaflet').Map} map */
export function syncImageMapMaxBoundsForZoom(L, map, aspectWOverH) {
  const pad = imageMapPadFractionForZoom(map.getZoom(), map.getMinZoom(), map.getMaxZoom());
  map.setMaxBounds(imageMapPaddedMaxBounds(L, aspectWOverH, pad));
}
